import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { Send, Phone, Linkedin, Instagram, Mail } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-surface">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-3 lg:px-10">
        <div>
          <p className="font-display text-2xl font-extrabold">
            <span className="gold-text">Sawtly</span>{" "}
            <span className="text-zinc-500 text-lg">صوتلي</span>
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-zinc-500">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <p className="overline-tag">{t.footer.pages}</p>
          <div className="mt-4 flex flex-col gap-3 text-sm text-zinc-400">
            <Link to="/blog" className="transition-colors hover:text-gold">
              {t.nav.blog}
            </Link>
            <Link to="/how-it-works" className="transition-colors hover:text-gold">
              {t.nav.howItWorks}
            </Link>
            <Link to="/case-study" className="transition-colors hover:text-gold">
              {t.nav.caseStudy}
            </Link>
            <Link to="/about" className="transition-colors hover:text-gold">
              {t.nav.about}
            </Link>
            <Link to="/privacy" className="transition-colors hover:text-gold">
              {t.footer.privacy}
            </Link>
          </div>
        </div>

        <div>
          <p className="overline-tag">{t.footer.contact}</p>
          <div className="mt-4 flex flex-wrap items-center gap-4">
            <a
              href="https://wa.me/639934916315"
              target="_blank"
              rel="noreferrer"
              className="text-zinc-400 transition-colors hover:text-gold"
              aria-label="WhatsApp"
            >
              <Phone size={20} />
            </a>
            <a
              href="https://t.me/SawtlyBot"
              target="_blank"
              rel="noreferrer"
              className="text-zinc-400 transition-colors hover:text-gold"
              aria-label="Telegram"
            >
              <Send size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/142887745/admin/dashboard/"
              target="_blank"
              rel="noreferrer"
              className="text-zinc-400 transition-colors hover:text-gold"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
            <a
              href="https://instagram.com/sawtly_"
              target="_blank"
              rel="noreferrer"
              className="text-zinc-400 transition-colors hover:text-gold"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href="mailto:contact@sawtly.net"
              className="text-zinc-400 transition-colors hover:text-gold"
              aria-label="Email"
            >
              <Mail size={20} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-zinc-600">
        {t.footer.rights}
      </div>
    </footer>
  );
};

export default Footer;
